module.exports = __webpack_public_path__ + "static/media/discord.3437c105.svg";